// 쿠키 파서(안전 디코드) _닉네임 확인용 | 250905 | smyun
export function getCookie(name: string): string | undefined {
    if (typeof document === "undefined") return;
    const kv = document.cookie
        .split(";")
        .map((s) => s.trim())
        .find((s) => s.startsWith(name + "="));
    if (!kv) return;
    try {
        return decodeURIComponent(kv.split("=")[1] ?? "");
    } catch {
        return kv.split("=")[1];
    }
}
